module.exports = __webpack_public_path__ + "static/media/XIVe.9a61e532.png";